import { IUser as UserInterface } from '@interfaces/IUser';
import { Button } from 'antd';
import React from 'react';

import I18n from '../i18n';
import styled from '../styled-components';
import Table, { ITableColumn } from './TableComponent';

interface IUserRadioSelectPropType {
    columns?: ITableColumn[];
    onShowMore: any;
    data: UserInterface[];
    itemSelectionChanged: any;
    loadingMoreData: boolean,
    hasMoreData: boolean;
    valueSelected: string;
    notScroll?: boolean;
};

interface IUserRadioSelectStateType {
    selectedRowKeys: any[],
};


const tableColumns: ITableColumn[] = [
    {
        title: 'table.users.name',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: 'table.auditors.registration',
        dataIndex: 'username',
        key: 'username',
        width: '30%',
    },
    {
        title: 'titles.processes',
        dataIndex: 'auditedGoal',
        key: 'id',
        width: '30%',
    },
];

export default class UserRadioSelect extends React.Component<IUserRadioSelectPropType, IUserRadioSelectStateType> {

    constructor(props: IUserRadioSelectPropType) {
        super(props);

        this.state = {
            selectedRowKeys: [],
        }
    }

    selectRow = async (record: any) => {
        const selectedRowKeys = [...this.state.selectedRowKeys];
        if (selectedRowKeys.indexOf(record.key) != -1) {
            selectedRowKeys.splice(selectedRowKeys.indexOf(record.key), 1);
        } else {
            selectedRowKeys[0] = record.key;
        }
        await this.setState({ selectedRowKeys });
        this.processIdFromSelected();
    }

    onSelectedRowKeysChange = async (selectedRowKeys: any) => {
        await this.setState({ selectedRowKeys });
        this.processIdFromSelected();
    }

    processIdFromSelected() {
        const { data } = this.props;
        let id = undefined;
        if (this.state.selectedRowKeys[0] !== undefined) {
            id = data.find(r => r.id === this.state.selectedRowKeys[0]).id
        }

        this.props.itemSelectionChanged(id);
    }

    formatTableData = () => {
        const { data } = this.props;
        let newTableData: UserInterface[] = [];

        if (data.length > 0) {
            data.map((item: UserInterface, i: number) => {
                let newItem: any = item;
                newItem.key = i;
                newTableData.push(newItem);
            })
        }
        return newTableData;
    }


    render() {
        const {
            loadingMoreData,
            hasMoreData,
            onShowMore,
            columns
        } = this.props;

        const { selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            type: "radio",
            onChange: this.onSelectedRowKeysChange,
        };

        /**
         * Ant has a way of having horizontal scroll on tables, which takes as an argument a number or a boolean (see scroll props)
         * Neither work 100%. I managed to make it work without writing too much bs css by calculating a number (which is arbitrary af)
         * based on a trial and error initial number (200) and a product of extra visible columns and YET another number (120). Those
         * numbers aren't pixels, so don't try and calculate whatever by that angle.
         */
        const columnsToTable = columns == undefined ? tableColumns : columns;
        const xScrollNumber = 200 + (columnsToTable.filter((column: ITableColumn) => !column.isHidden).length * 120)

        return (
            <Wrapper>
                <AssignerRadioTable>
                    {/* USERS RADIO SELECT */}
                    <Table
                        columns={columnsToTable}
                        data={this.formatTableData()}
                        rowSelection={rowSelection}
                        noPagination={true}
                        showConfirmationModal={false}
                        onSelectRow={this.selectRow}
                        scroll={ this.props.notScroll ? { y: 240 } :{ x: xScrollNumber, y: 240 }}
                    />
                    {/* LOAD MORE USERS */}
                    {hasMoreData && (
                        <Button
                            className="loading-more"
                            type="primary"
                            ghost
                            onClick={onShowMore}
                            loading={loadingMoreData}>
                            {I18n.l('common.seeMore')}
                        </Button>
                    )}
                </AssignerRadioTable>
            </Wrapper>
        );
    }
}

const AssignerRadioTable = styled.div`
    padding-top: 15px;
    overflow-y: auto;
    max-height: 335px;

    .column-first{
        font-size: 18px;
        font-weight: bold;
        text-indent: 25px;
    }
    .column-others{
        font-size: 18px;
        font-weight: bold;
    }
    .column-margin-left{
        margin-left: 185px;
    }
`;

const Wrapper = styled.div`
    display: flex;
    flex: 1;
    flex-flow: column;
    overflow-x: auto;
    width: 100%;

    .ant-table-wrapper {
        button {
            border: 0;
        }
    }

    .ant-table-fixed-header .ant-table-scroll .ant-table-header {
        overflow: hidden;
    }

    .action-buttons {
        display: block;
        text-align: right;
        button {
            margin: 0 0 3px 0px;
            padding: 3px;
            width: 70px;
        }
    }

    table {
        td {
            .disabled {
                color: #ccc;
            }
        }
    }
`;